import { render } from "./TheRandomIcon.vue?vue&type=template&id=eb52f6d2&scoped=true"
import script from "./TheRandomIcon.vue?vue&type=script&lang=js"
export * from "./TheRandomIcon.vue?vue&type=script&lang=js"

import "./TheRandomIcon.vue?vue&type=style&index=0&id=eb52f6d2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb52f6d2"]])

export default __exports__